import { gql } from 'urql';
import { PRODUCT } from '../client';
import { ISSUE_FRAGMENT } from './fragments';

export const GET_ALL_STOP_STATUSES = gql`
  ${ISSUE_FRAGMENT}
  query ${PRODUCT}GetAllStopStatuses($input: RoutesInput!) {
    routes(input: $input) {
      id
      stops {
        ... on Delivery {
          location {
            effectivelyExcluded
          }
          id
          deliveryStatusDmp
          compostCollectionRequired
          compostCollectedAt
          donationRequired
          donationCollectedAt
          deliveryNote
          issues {
            ...IssueFragment
          }
          orders {
            id
            warehouseNote
            deliveredAt
            partiallyDelivered
            itemLevelTracking
            deliveryMethod
            location {
              membershipTier
              locationDeliveryWindow {
                startTime
                endTime
              }
              scheduledDeliveryTimeSource
              isDoordash
            }
            issues {
              ...IssueFragment
            }
            vendor {
              name
              legalName
              isWarehouse
            }
            orderLines {
              id
              sku {
                id
                refrigerationState
                categoryName
                subcategoryName
              }
            }
            scheduledDeliveryTime {
              earliest
              latest
              timeZone
            }
          }
          reminderMessage
          tasks {
            id
            status
          }
          hasRepeatedAccessIssues
          isFirstDelivery
        }
        ... on PickUp {
          id
          deliveryStatusDmp
          issues {
            ...IssueFragment
          }
          orders {
            id
            warehouseNote
            collectedAt
            location {
              membershipTier
              locationDeliveryWindow {
                startTime
                endTime
              }
              scheduledDeliveryTimeSource
            }
            issues {
              ...IssueFragment
            }
          }
          reminderMessage
        }
      }
      redeliveryStops {
        location {
          effectivelyExcluded
        }
        id
        deliveryStatusDmp
        hasRepeatedAccessIssues
        reminderMessage
        deliveryStop {
          id
        }
        issues {
          ...IssueFragment
        }
        orders {
          id
          warehouseNote
          itemLevelTracking
          deliveryMethod
          location {
            membershipTier
            locationDeliveryWindow {
              startTime
              endTime
            }
            scheduledDeliveryTimeSource
            isDoordash
          }
          scheduledDeliveryTime {
            earliest
            latest
            timeZone
          }
          issues {
            ...IssueFragment
          }
          vendor {
            name
            legalName
            isWarehouse
          }
          orderLines {
            id
            sku {
              id
              refrigerationState
              categoryName
              subcategoryName
            }
          }
        }
      }
    }
  }
`;
